export function DaySwitcher({ days, active, onChange, testPrefix = "day" }) {
  return (
    <div className="flex gap-1.5 mb-3 no-print overflow-x-auto" data-testid={`${testPrefix}-switcher`}>
      {days.map((d) => (
        <button key={d} type="button" onClick={() => onChange(d)} data-testid={`${testPrefix}-day-${d.toLowerCase()}`}
          className={`flex-1 min-w-[52px] px-2 py-2 rounded-xl border-2 border-zinc-900 font-display font-bold text-sm transition-colors duration-150 ${d === active ? "bg-zinc-900 text-white" : "bg-white text-zinc-500"}`}>
          {d.slice(0, 3)}
        </button>
      ))}
    </div>
  );
}
